<template>
  <v-layout
    class="mt-4 align-stretch volunteers"
    :wrap="$vuetify.breakpoint.mdAndDown"
  >
    <v-flex
      v-bind="attributes"
      class="volunteers__item pr-3"
    >
      <div>
        <h4 class="display-1 display-1_dark mb-2 d-inline-block">
          {{ $t('family_card.volunteers.main') }}
        </h4>
      </div>
      <a
        v-if="canManageVolunteers"
        class="small fw-400"
        @click="assignVolunteer()"
      >{{
        'Zarządzaj'
      }}</a>
      <div
        v-if="hasPrimaryVolunteer"
        class="mt-2"
      >
        <p class="mb-0">
          {{ primaryVolunteerName }}
        </p>
        <p
          v-if="primaryVolunteerEmail"
          class="mb-0"
        >
          <BaseEmail :email="primaryVolunteerEmail" />
        </p>
        <p
          v-if="primaryVolunteerPhones"
          class="mb-0"
        >
          <PhoneNumber :number="primaryVolunteerPhones" />
        </p>
      </div>
      <div v-else>
        <p
          v-if="!(isCurrentEdition && canChoosePrimary)"
          class="mb-0"
        >
          {{ $t('list.none') }}
        </p>
      </div>
    </v-flex>
    <v-flex
      v-bind="attributes"
      class="volunteers__item"
      :class="[mdAndDownScreen ? 'pr-3 pl-0' : 'px-3']"
    >
      <div>
        <h4 class="display-1 display-1_dark mb-2 d-inline-block">
          {{ $t('family_card.volunteers.secondary') }}
        </h4>
      </div>
      <div
        v-if="hasSecondaryVolunteer"
        class="mt-2"
      >
        <p class="mb-0">
          {{ secondaryVolunteerName }}
        </p>
        <p
          v-if="secondaryVolunteerEmail"
          class="mb-0"
        >
          <BaseEmail :email="secondaryVolunteerEmail" />
        </p>
        <p
          v-if="secondaryVolunteerPhones"
          class="mb-0"
        >
          <PhoneNumber :number="secondaryVolunteerPhones" />
        </p>
      </div>
      <div v-else>
        <p
          v-if="!(isCurrentEdition && canChooseSecondary)"
          class="mb-0"
        >
          {{ $t('list.none') }}
        </p>
      </div>
    </v-flex>
    <v-flex
      v-if="isCurrentEdition"
      v-bind="attributes"
      class="volunteers__item"
      :class="[mdAndDownScreen ? 'pr-3 pl-0' : 'px-3']"
    >
      <h4 class="display-1 display-1_dark">
        {{ $t('family_card.volunteers.leader') }}
      </h4>
      <div
        v-for="(item, index) in regionLeader"
        :key="index"
        class="mt-2"
      >
        <p class="mb-0">
          {{ item.full_name }}
        </p>
        <p class="mb-0">
          <BaseEmail :email="item.email" />
        </p>
        <p class="mb-0">
          <PhoneNumber :number="item.phone" />
        </p>
      </div>
      <div
        v-if="regionLeader != null && regionLeader.length === 0"
        class="mt-2"
      >
        <p class="mb-0">
          {{ $t('list.none') }}
        </p>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import BaseEmail from '@/components/widgets/BaseEmail.vue';
import PhoneNumber from '@/components/widgets/PhoneNumber.vue';
import filters from '@/constants/filters';

export default {
    name: 'VolunteersInfo',
    filters: {
        ...filters
    },
    components: {
        BaseEmail,
        PhoneNumber
    },
    props: {
        hasPermissionVolunteerAssign: {
            required: true,
            default: false
        },
        primaryVolunteer: {
            required: true,
            default: null
        },
        secondaryVolunteer: {
            required: true,
            default: null
        },
        regionLeader: {
            default: () => []
        },
        isDisabled: {
            default: false,
            type: Boolean
        },
        canBeExcluded: {
            default: true,
            type: Boolean
        }
    },
    computed: {
        mdAndDownScreen () {
            return this.$vuetify.breakpoint.mdAndDown;
        },
        smAndDownScreen () {
            return this.$vuetify.breakpoint.smAndDown;
        },
        hasPrimaryVolunteer () {
            return !!this.primaryVolunteer;
        },
        hasSecondaryVolunteer () {
            return !!this.secondaryVolunteer;
        },
        secondaryVolunteerName () {
            return this.secondaryVolunteer ? this.secondaryVolunteer.full_name : this.$t('list.none');
        },
        primaryVolunteerName () {
            return this.primaryVolunteer ? this.primaryVolunteer.full_name : this.$t('list.none');
        },
        primaryVolunteerEmail () {
            return this.primaryVolunteer ? this.primaryVolunteer.email : null;
        },
        secondaryVolunteerEmail () {
            return this.secondaryVolunteer ? this.secondaryVolunteer.email : null;
        },
        primaryVolunteerPhones () {
            return this.primaryVolunteer ? this.primaryVolunteer.phone : null;
        },
        secondaryVolunteerPhones () {
            return this.secondaryVolunteer ? this.secondaryVolunteer.phone : null;
        },
        isCurrentEdition () {
            return this.$store.getters['family/isCurrentEdition'];
        },
        canChangePrimary () {
            return (
                this.hasPermissionVolunteerAssign &&
        this.hasPrimaryVolunteer &&
        !this.isDisabled &&
        this.canBeExcluded
            );
        },
        canChoosePrimary () {
            return this.hasPermissionVolunteerAssign && this.canBeExcluded;
        },
        canChangeSecondary () {
            return (
                this.hasPermissionVolunteerAssign &&
        this.hasSecondaryVolunteer &&
        !this.isDisabled &&
        this.canBeExcluded
            );
        },
        canChooseSecondary () {
            return this.hasPermissionVolunteerAssign && this.canBeExcluded;
        },
        canManageVolunteers () {
            return (
                this.isCurrentEdition &&
        (this.canChoosePrimary ||
          this.canChangePrimary ||
          this.canChooseSecondary ||
          this.canChangeSecondary)
            );
        },
        attributes () {
            if (this.isCurrentEdition) {
                return {
                    lg4: true,
                    md6: true
                };
            } else {
                return {
                    lg6: true,
                    md6: true
                };
            }
        }
    },
    methods: {
        assignVolunteer () {
            this.$emit('assignVolunteer');
        }
    }
};
</script>

<style scoped></style>
